type Props = {
    name: string;
    checked: boolean;
    onToggle: () => void;
};

export default function SalesChannelOption({ name, checked, onToggle }: Props) {
    return (
        <label className="salesChannel__option">
            <input type="checkbox" checked={checked} onChange={onToggle} />
            <span className="salesChannel__name">{name}</span>
        </label>
    );
}
